/* Evyn Financial Group — theme scripts */
(function () {
  'use strict';

  var ICONS = {
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6l7-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    warn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l9.5 17h-19L12 3z"/><path d="M12 10v4M12 17.5v.01"/></svg>',
    err: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/></svg>',
    spin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur=".8s" repeatCount="indefinite"/></path></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Mobile menu */
  document.querySelectorAll('[data-efg-menu]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
    });
  });

  /* Header shadow on scroll */
  var hdr = document.querySelector('.efg-header');
  if (hdr) { var onS = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); }; window.addEventListener('scroll', onS, { passive: true }); onS(); }

  /* Stagger siblings that reveal together */
  document.querySelectorAll('.efg-steps, .efg-types, .efg-checks, .efg-trust__grid').forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (c, i) { c.classList.add('efg-reveal'); c.style.setProperty('--d', (i * 0.09) + 's'); });
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.efg-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.efg-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Employee verification ---------- */
  function toHandle(id) {
    return id.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  var clockTimer = null;
  function startClock() {
    if (clockTimer) clearInterval(clockTimer);
    var tick = function () {
      var els = document.querySelectorAll('[data-efg-clock]'); if (!els.length) return;
      var d = new Date();
      var t = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) + ' · ' + d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', second: '2-digit' });
      els.forEach(function (el) { el.textContent = t; });
    };
    tick(); clockTimer = setInterval(tick, 1000);
  }

  function renderSide(box, state, data, cfg) {
    var sec = box.closest('section'); if (!sec) return;
    var side = sec.querySelector('[data-efg-verify-side]'); if (!side) return;
    var def = side.querySelector('[data-efg-side-default]'), prof = side.querySelector('[data-efg-side-profile]');
    if (!prof) return;
    if (state === 'loading') { side.classList.add('is-loading'); return; }
    side.classList.remove('is-loading');
    if (state !== 'ok' && state !== 'warn') {
      prof.hidden = true; prof.innerHTML = ''; if (def) def.hidden = false; side.classList.remove('has-profile'); box.classList.remove('has-side');
      return;
    }
    var ok = state === 'ok';
    var initials = (data.name || '?').split(' ').map(function (p) { return p.charAt(0); }).join('').slice(0, 2);
    prof.innerHTML =
      '<div class="efg-repcard__top">' + (cfg.logo ? '<img src="' + esc(cfg.logo) + '" alt="' + esc(cfg.brand) + '">' : esc(cfg.brand)) +
        '<span class="efg-repcard__stamp efg-repcard__stamp--' + (ok ? 'ok' : 'warn') + '">' + (ok ? ICONS.ok + 'Verified' : ICONS.warn + 'Not active') + '</span></div>' +
      '<div class="efg-repcard__photo">' + (data.photo ? '<img src="' + esc(data.photo) + '" alt="Photo of ' + esc(data.name) + '">' : '<span aria-hidden="true">' + esc(initials) + '</span>') + '</div>' +
      '<div class="efg-repcard__body">' +
        '<div class="efg-repcard__name">' + esc(data.name) + '</div>' +
        (data.title ? '<div class="efg-repcard__title">' + esc(data.title) + '</div>' : '') +
        '<dl class="efg-repcard__dl">' +
          '<div><dt>Status</dt><dd>' + (ok ? '<span class="efg-live-dot"></span> Active' : 'Not currently active') + '</dd></div>' +
          (data.license ? '<div><dt>License</dt><dd>' + esc(data.license) + '</dd></div>' : '') +
          '<div><dt>Company</dt><dd>' + esc(cfg.brand || 'Evyn Financial Group') + '</dd></div>' +
          '<div><dt>Checked</dt><dd data-efg-clock></dd></div>' +
        '</dl>' +
      '</div>';
    if (def) def.hidden = true;
    prof.hidden = false;
    side.classList.add('has-profile'); box.classList.add('has-side');
    prof.classList.remove('is-in'); void prof.offsetWidth; prof.classList.add('is-in');
  }

  function renderResult(box, state, data, cfg) {
    box.className = 'efg-result is-shown efg-result--' + state;
    var html = '';
    if (state === 'loading') {
      html = '<div class="efg-result__status">' + ICONS.spin + 'Checking our records…</div>';
    } else if (state === 'ok') {
      var initials = (data.name || '?').split(' ').map(function (p) { return p.charAt(0); }).join('').slice(0, 2);
      html = '<div class="efg-result__status">' + ICONS.ok + esc(cfg.okTitle) + '</div>' +
        '<p class="efg-result__msg">' + esc(window.innerWidth > 860 ? cfg.okMsg.replace(/below/g, 'on the left') : cfg.okMsg) + '</p>' +
        '<div class="efg-idcard">' +
          '<div class="efg-idcard__top">' + (cfg.logo ? '<img src="' + esc(cfg.logo) + '" alt="' + esc(cfg.brand) + '">' : esc(cfg.brand)) + '<span class="efg-idcard__stamp">' + ICONS.ok + 'Verified</span></div>' +
          '<div class="efg-idcard__body">' +
            (data.photo ? '<img class="efg-idcard__photo" src="' + esc(data.photo) + '" alt="Photo of ' + esc(data.name) + '">' : '<div class="efg-idcard__photo efg-idcard__photo--empty" aria-hidden="true">' + esc(initials) + '</div>') +
            '<div class="efg-idcard__info">' +
              '<div class="efg-idcard__name">' + esc(data.name) + '</div>' +
              (data.title ? '<div class="efg-idcard__title">' + esc(data.title) + '</div>' : '') +
              '<dl>' +
                '<dt>Status</dt><dd><span class="efg-live-dot"></span> Active</dd>' +
                (data.license ? '<dt>License</dt><dd>' + esc(data.license) + '</dd>' : '') +
                '<dt>Checked</dt><dd data-efg-clock></dd>' +
              '</dl>' +
            '</div>' +
          '</div>' +
          '<div class="efg-idcard__foot">Live record — the time above updates every second, so a screenshot can\'t fake it.</div>' +
        '</div>';
    } else if (state === 'warn') {
      html = '<div class="efg-result__status">' + ICONS.warn + esc(cfg.inactiveTitle) + '</div>' +
        '<p class="efg-result__msg"><b>' + esc(data.name) + '</b> is not currently authorized. ' + esc(cfg.inactiveMsg) + '</p>';
    } else {
      html = '<div class="efg-result__status">' + ICONS.err + esc(cfg.failTitle) + '</div>' +
        '<p class="efg-result__msg">' + (data && data.name ? 'We could not find a representative named <b>' + esc(data.name) + '</b>. ' : '') + esc(cfg.failMsg) + '</p>';
    }
    box.innerHTML = html;
    renderSide(box, state, data, cfg);
    startClock(box);
    if (state !== 'loading') box.focus({ preventScroll: true });
  }

  function lookup(id, cfg) {
    // Preview / demo mode
    if (window.EFG_DEMO) {
      return new Promise(function (resolve) {
        setTimeout(function () { resolve(window.EFG_DEMO[toHandle(id)] || null); }, 650);
      });
    }
    var url = cfg.base.replace(/\/?$/, '/') + encodeURIComponent(toHandle(id));
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (res) {
      if (res.status === 404) return null;
      if (!res.ok) throw new Error('lookup failed');
      return res.text().then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-efg-employee]');
        if (!el) return null;
        return {
          name: el.getAttribute('data-name'), title: el.getAttribute('data-title'),
          license: el.getAttribute('data-license'), photo: el.getAttribute('data-photo'), status: el.getAttribute('data-status')
        };
      });
    });
  }

  function titleCase(v) { return String(v || '').trim().replace(/\s+/g, ' ').toLowerCase().replace(/(^|[\s\-'])\S/g, function (m) { return m.toUpperCase(); }); }

  document.querySelectorAll('[data-efg-verify]').forEach(function (form) {
    var first = form.querySelector('[data-efg-first]');
    var last = form.querySelector('[data-efg-last]');
    var box = form.parentNode.querySelector('[data-efg-result]');
    var cfg = {
      base: form.getAttribute('data-base') || '/pages/employees/',
      okTitle: form.getAttribute('data-ok-title') || 'Verified representative',
      okMsg: form.getAttribute('data-ok-msg') || '',
      inactiveTitle: form.getAttribute('data-inactive-title') || 'Not currently active',
      inactiveMsg: form.getAttribute('data-inactive-msg') || '',
      failTitle: form.getAttribute('data-fail-title') || 'No match found',
      failMsg: form.getAttribute('data-fail-msg') || '',
      logo: form.getAttribute('data-logo') || '',
      brand: form.getAttribute('data-brand') || ''
    };
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.get('first') && qs.get('last')) {
        first.value = qs.get('first'); last.value = qs.get('last');
        setTimeout(function () {
          var sec = form.closest('section'); if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        }, 350);
      }
    } catch (err) {}
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = titleCase(first.value), l = titleCase(last.value), bad = null;
      [[first, f], [last, l]].forEach(function (pair) {
        pair[0].setAttribute('aria-invalid', pair[1] ? 'false' : 'true');
        if (!pair[1] && !bad) bad = pair[0];
      });
      if (bad) { bad.focus(); return; }
      first.value = f; last.value = l;
      var full = f + ' ' + l;
      renderResult(box, 'loading', null, cfg);
      lookup(full, cfg).then(function (rec) {
        if (!rec) return renderResult(box, 'err', { name: full }, cfg);
        var active = String(rec.status || 'active').toLowerCase().indexOf('active') === 0;
        renderResult(box, active ? 'ok' : 'warn', rec, cfg);
      }).catch(function () { renderResult(box, 'err', { name: full }, cfg); });
    });
  });

  /* ---------- Quote inquiry form ---------- */
  document.querySelectorAll('[data-efg-quote]').forEach(function (host) {
    var form = host.tagName === 'FORM' ? host : host.querySelector('form');
    if (!form) return;
    var dob = form.querySelector('[data-efg-dob]');
    if (dob) {
      var t = new Date();
      dob.max = new Date(t.getFullYear() - 18, t.getMonth(), t.getDate()).toISOString().slice(0, 10);
      dob.min = new Date(t.getFullYear() - 90, t.getMonth(), t.getDate()).toISOString().slice(0, 10);
    }
    // "None" chip clears the others and vice-versa
    var chips = form.querySelectorAll('[data-efg-health]');
    chips.forEach(function (c) {
      c.addEventListener('change', function () {
        if (!c.checked) return;
        if (c.value === 'None') chips.forEach(function (o) { if (o !== c) o.checked = false; });
        else chips.forEach(function (o) { if (o.value === 'None') o.checked = false; });
      });
    });
    var touched = false;
    function fieldOk(f) {
      if (f.type === 'radio') return !!form.querySelector('input[name="' + f.name + '"]:checked');
      if (f.type === 'checkbox') return f.checked;
      return f.value.trim() !== '' && f.checkValidity();
    }
    function validate(mark) {
      var bad = null;
      form.querySelectorAll('[required]').forEach(function (f) {
        var ok = fieldOk(f);
        if (mark) f.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok && !bad) bad = f;
      });
      form.querySelectorAll('[data-efg-require-one]').forEach(function (g) {
        var ok = !!g.querySelector('input:checked');
        if (mark) g.classList.toggle('is-invalid', !ok);
        if (!ok && !bad) bad = g.querySelector('input');
      });
      return bad;
    }
    function progress() {
      var items = [], seen = {};
      form.querySelectorAll('[required]').forEach(function (f) {
        if (f.type === 'radio') { if (seen[f.name]) return; seen[f.name] = 1; }
        items.push(fieldOk(f));
      });
      form.querySelectorAll('[data-efg-require-one]').forEach(function (g) { if (!g.querySelector('[required]')) items.push(!!g.querySelector('input:checked')); });
      var pct = Math.round(items.filter(Boolean).length / items.length * 100);
      var bar = form.querySelector('[data-efg-progress]'), txt = form.querySelector('[data-efg-progress-text]');
      if (bar) bar.style.width = pct + '%';
      if (txt) txt.textContent = pct + '%';
      if (touched) validate(true);
      if (touched && !validate(false)) { var eb = form.querySelector('[data-efg-form-error]'); if (eb) eb.hidden = true; }
    }
    form.addEventListener('input', progress);
    form.addEventListener('change', progress);

    /* Prefill coverage amount from URL (?amount=) */
    try {
      var amt = new URLSearchParams(window.location.search).get('amount');
      var amtSel = form.querySelector('#q-amt');
      if (amt && amtSel) { Array.prototype.forEach.call(amtSel.options, function (o) { if (o.text === amt) amtSel.value = o.value || o.text; }); }
    } catch (err) {}
    progress();

    /* Step-by-step wizard */
    var steps = form.querySelectorAll('fieldset[data-step]');
    var nav = form.querySelector('[data-efg-stepnav]');
    var finalBox = form.querySelector('[data-efg-final]');
    var wiz = form.querySelectorAll('[data-efg-wiz] li');
    var cur = 0;
    function stepBad(i) {
      var bad = null, fs = steps[i];
      fs.querySelectorAll('[required]').forEach(function (f) { var ok = fieldOk(f); f.setAttribute('aria-invalid', ok ? 'false' : 'true'); if (!ok && !bad) bad = f; });
      fs.querySelectorAll('[data-efg-require-one]').forEach(function (g) { var ok = !!g.querySelector('input:checked'); g.classList.toggle('is-invalid', !ok); if (!ok && !bad) bad = g.querySelector('input'); });
      return bad;
    }
    function show(i, dir) {
      cur = i;
      steps.forEach(function (fs, k) {
        fs.hidden = k !== i;
        if (k === i) { fs.classList.remove('efg-step-in', 'efg-step-in--back'); void fs.offsetWidth; fs.classList.add(dir < 0 ? 'efg-step-in--back' : 'efg-step-in'); }
      });
      wiz.forEach(function (li, k) { li.classList.toggle('is-active', k === i); li.classList.toggle('is-done', k < i); });
      nav.hidden = false;
      nav.querySelector('[data-efg-back]').style.visibility = i === 0 ? 'hidden' : 'visible';
      nav.querySelector('[data-efg-next]').hidden = i === steps.length - 1;
      if (finalBox) finalBox.hidden = i !== steps.length - 1;
    }
    if (steps.length > 1 && nav) {
      form.classList.add('is-wizard');
      show(0, 1);
      nav.querySelector('[data-efg-next]').addEventListener('click', function () {
        var bad = stepBad(cur);
        var eb = form.querySelector('[data-efg-form-error]');
        if (bad) { if (eb) eb.hidden = false; bad.focus(); return; }
        if (eb) eb.hidden = true;
        show(cur + 1, 1);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      nav.querySelector('[data-efg-back]').addEventListener('click', function () { show(cur - 1, -1); form.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      wiz.forEach(function (li, k) { li.addEventListener('click', function () { if (k < cur) show(k, -1); }); });
    }

    form.addEventListener('submit', function (e) {
      touched = true;
      // Combine checked conditions into one readable field
      var hidden = form.querySelector('[data-efg-health-summary]');
      if (hidden) {
        var picked = []; chips.forEach(function (c) { if (c.checked) picked.push(c.value); });
        hidden.value = picked.join(', ') || 'Not specified';
      }
      var hft = form.querySelector('[data-efg-hft]'), hin = form.querySelector('[data-efg-hin]'), hsum = form.querySelector('[data-efg-height]');
      if (hft && hin && hsum) hsum.value = (hft.value || '?') + ' ft ' + (hin.value || '0') + ' in';

      var bad = validate(true);
      var errBox = form.querySelector('[data-efg-form-error]');
      if (bad) { e.preventDefault(); if (errBox) errBox.hidden = false;
        var fsBad = bad.closest('fieldset[data-step]'); if (fsBad && fsBad.hidden) { var idx = Array.prototype.indexOf.call(steps, fsBad); show(idx, -1); }
        bad.focus(); bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (errBox) errBox.hidden = true;

      if (window.EFG_DEMO) {
        e.preventDefault();
        var wrap = form.closest('[data-efg-quote-wrap]') || form;
        var success = wrap.querySelector('[data-efg-success]');
        form.hidden = true; if (success) { success.hidden = false; success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }

      // Save the lead to Shopify Customers (tagged), then send the full request by email.
      if (form.dataset.efgSent) return;
      e.preventDefault();
      form.dataset.efgSent = '1';
      var btn = form.querySelector('button[type=submit]'); if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      var val = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; };
      var slug = function (t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 30); };
      var tags = ['quote-request'];
      if (val('ZIP code')) tags.push('zip-' + val('ZIP code'));
      if (val('Coverage type')) tags.push('coverage-' + slug(val('Coverage type')));
      if (val('Referring rep name')) tags.push('rep-' + slug(val('Referring rep name')));
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('contact[email]', val('email'));
      fd.append('contact[first_name]', val('First name'));
      fd.append('contact[last_name]', val('Last name'));
      fd.append('contact[phone]', val('phone'));
      fd.append('contact[tags]', tags.join(', '));
      var done = false, finish = function () { if (done) return; done = true; HTMLFormElement.prototype.submit.call(form); };
      setTimeout(finish, 3000);
      try { fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).then(finish, finish); } catch (err) { finish(); }
    });
  });

  /* ---------- Count-up stats ---------- */
  var counters = document.querySelectorAll('[data-efg-count]');
  if (counters.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return; cio.unobserve(en.target);
        var el = en.target, txt = el.textContent.trim(), m = txt.match(/^(\D*)(\d+)(.*)$/);
        if (!m) return;
        var end = parseInt(m[2], 10), t0 = null, dur = 1400;
        if (end === 0) return;
        var step = function (ts) { if (!t0) t0 = ts; var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = m[1] + Math.round(end * e) + m[3]; if (p < 1) requestAnimationFrame(step); };
        el.textContent = m[1] + '0' + m[3]; requestAnimationFrame(step);
      });
    }, { threshold: .6 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---------- Mobile action bar ---------- */
  var mbar = document.querySelector('[data-efg-mobilebar]');
  if (mbar) {
    var onBar = function () { mbar.classList.toggle('is-shown', window.scrollY > 420); };
    window.addEventListener('scroll', onBar, { passive: true }); onBar();
  }

  /* ---------- Hero parallax ---------- */
  var heroImg = document.querySelector('.efg-hero__media');
  if (heroImg && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY; if (y < 900) heroImg.style.transform = 'translate3d(0,' + (y * 0.25) + 'px,0)';
    }, { passive: true });
  }
})();
